import type { CmsProps } from '../../../types/cms'
import styled from '@emotion/styled'
import isPropValid from '@emotion/is-prop-valid'
import { Stack } from '@mui/material'

export const QuoteContainer = styled(Stack, {
  shouldForwardProp: prop => isPropValid(prop) && prop !== 'backgroundColour',
})<CmsProps>`
  background-color: ${({ backgroundColour }) => `${backgroundColour}`};

  .quote-text {
    font-size: 1.125rem;
    line-height: 1.75rem;
    color: #fff;
    font-weight: 500;
    font-style: italic;
  }

  .quote-author {
    font-size: 1.125rem;
    line-height: 1.75rem;
    color: #fff;
    font-weight: 700;
    font-style: normal;
  }

  p {
    color: #fff;
  }

  h1,
  h2,
  h3,
  h4 {
    color: #fff;
    text-align: center;
  }
`
